import en from "./meta.en";

const metaList = {
  en
};

export default lang => {
  const languageMeta = metaList[lang];
  if (languageMeta === undefined) {
    throw Error(`No meta is provided for language: ${lang}`);
  }

  return languageMeta;
}
